import api from '../../../config';

const path = 'v1/assets-infrastruktur/status';

export default {
  get: () => api.get(path),
  getSubStati: () => api.get(`${path}/substati`),
  getById: (id) => api.get(`${path}/${id}`),
};
